import { TaskGroupUsers } from "./TasksAndGroups";

export class IMessagesTasksInbox {
     FromUserId: string;
     Priority: number;
     DueDate: string;
     TypeId: number;
     PatientId: number;
     DPatId: number;
     Subject: string;
     Note: string;
     IsSendEmailNotification: boolean;
     Status: number;
     AcceptedBy: string;
     RejectedBy: string;
     CompleeteedBy: string;
     CreatedOn: string;
     CreatedBy: string;
     MessagesType: string;
     TypeOfMessage: string;
     OldTaskId: number;
     PatientName: string;
     UserName: string;
     AcceptedByName: string;
     LocationName: string;
     LocationId: number;
     StatusName: string;
     PriorityName: string;
     TypeName: string;
     ToUserName: string;
     CCUserName: string;
     ToUserIds: string;
     CCUserIds: string;
     IsFroward: boolean;
     ToUserIdList: userGroupObj[];
     CCUserIdList: userGroupObj[];
     TaskJsonObj: string;
     MessageTaskMasterId?: number;
     RequestType: string;
     RejectResult: string;
     FrmUserId: string; // From User Id
     CreatedDate: string;
     FacilityId: number;
     MailStatus: number;
     MailDueDate: string;
     FromUserEmail: string;
     IsReaded: boolean;
     IsUserMappingId: number;
     AllReplyCCUserIds: string;
     AllReplyToUserIds: string;
     ReplyandForwardStatus: number;
     patientDob : string;
}
export class userGroupObj {
     UserID: string;
     UserName: string;
     EmailId: string;
     GroupId: number;
}
export class ITaskReply {
     ReplyId: number;
     TaskId: number;
     FromUserId: string;
     ReplyedTo: string;
     Note: string;
     CreatedOn: string;
     CreatedBy: string;
     UserName: string;
     FacilityId: number;
}

export class AcceptRejectUsers {
     IsAccept: string;
     IsReject: string;
     ARTaskUserIds: string;
     MailUserIds: string;
     MasterTaskId: number;
     TaskId: number;
}